export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE_START = 0;
export const RELAY_MODULE_STATUS_CONNECTED = 'RELAY_MODULE_STATUS_CONNECTED';
